import React, { ReactNode } from 'react';
import { Paper, Typography, Box, useTheme, Grow } from '@mui/material';

type KPICardProps = {
  title: string;
  value: ReactNode;
  icon: ReactNode;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'default';
  delay?: number;
};

export const KPICard: React.FC<KPICardProps> = ({ 
  title, 
  value, 
  icon, 
  color = 'primary',
  delay = 0
}) => {
  const theme = useTheme();
  
  const getColorValue = () => {
    switch (color) {
      case 'primary':
        return theme.palette.primary.main;
      case 'secondary':
        return theme.palette.secondary.main;
      case 'success':
        return theme.palette.success.main;
      case 'error':
        return theme.palette.error.main;
      case 'warning':
        return theme.palette.warning.main;
      case 'info':
        return theme.palette.info.main;
      default:
        return undefined;
    }
  };
  
  const colorValue = getColorValue();

  return (
    <Grow in={true} style={{ transformOrigin: '0 0 0' }} timeout={500 + delay}>
    <Paper
        className="hover-lift"
        elevation={2} 
      sx={{
          p: 2, 
          height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 3,
          overflow: 'hidden',
        position: 'relative',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 16px 0 rgba(0,0,0,0.1)',
          },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
            height: '4px',
            backgroundColor: colorValue,
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Box 
          sx={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
              backgroundColor: colorValue ? `${colorValue}15` : 'transparent',
              color: colorValue,
              borderRadius: '50%',
              p: 1,
              mr: 1
          }}
        >
          {icon}
        </Box>
      <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ fontWeight: 'medium' }}
      >
        {title}
      </Typography>
        </Box>
      <Typography 
        variant="h4" 
          component="div" 
        sx={{ 
            flexGrow: 1, 
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            color: colorValue || theme.palette.text.primary
        }}
      >
        {value}
      </Typography>
    </Paper>
    </Grow>
  );
}; 